import { useCallback } from 'react';
import { useAutocomplete } from '@refinedev/mui';
import { useCreate, useInvalidate, useNotification } from '@refinedev/core';
import { HttpError } from '@refinedev/core';
import { useTranslation } from 'react-i18next';
import { StudyCategory } from '@aphp-ema/common/study';
import logger from '@/core/services';

export const useCategoryForm = () => {
  const { t } = useTranslation();
  const { open: openNotification } = useNotification();
  const invalidate = useInvalidate();

  const { autocompleteProps } = useAutocomplete<StudyCategory>({
    resource: 'admin/studies/categories',
  });

  const { mutateAsync: mutateCategory, isLoading: isCreatingCategory } =
    useCreate<StudyCategory, HttpError, { label: string }>({
      resource: 'admin/studies/categories',
      mutationOptions: {
        onSuccess: () => {
          invalidate({
            resource: 'admin/studies/categories',
            invalidates: ['list'],
          });
        },
        onError: (error: HttpError) => {
          logger.error('Error creating category:', error);
          openNotification?.({
            type: 'error',
            message: t('notifications.errorCreatingCategoryInternal'),
          });
        },
      },
    });

  const createCategory = useCallback(
    async (labelToCreate: string) => {
      const result = await mutateCategory({ values: { label: labelToCreate } });
      return result.data;
    },
    [mutateCategory],
  );

  return {
    autocompleteProps,
    createCategory,
    isCreatingCategory,
  };
};
